import { action } from 'typesafe-actions';
import { ISearchResult } from '@gerdau/hefesto/SearchField/SearchField.types';
import { Types, FAQProps, HelpCenterCategory, HelpCenterTopic } from './types';

export const loadHelpCenter = () => action(Types.LOAD_HELPCENTER);
export const loadHelpCenterSuccess = (faq: FAQProps) =>
  action(Types.LOAD_HELPCENTER_SUCCESS, {
    faq
  });
export const loadHelpCenterFailure = (error: unknown) =>
  action(Types.LOAD_HELPCENTER_FAILURE, { error });

export const loadHelpCenterQuery = (query: string) =>
  action(Types.LOAD_HELPCENTER_QUERY, {
    faq: {
      categories: [],
      question: [],
      query: {
        searchTerm: query,
        results: []
      },
      suggestions: []
    }
  });
export const loadHelpCenterQuerySuccess = (faq: FAQProps) =>
  action(Types.LOAD_HELPCENTER_QUERY_SUCCESS, { faq });
export const loadHelpCenterQueryFailure = (error: unknown) =>
  action(Types.LOAD_HELPCENTER_QUERY_FAILURE, { error });
export const loadHelpCenterQueryTopicsSuccess = (results: HelpCenterTopic[]) =>
  action(Types.LOAD_HELPCENTER_QUERY_TOPICS_SUCCESS, { results });
export const loadHelpCenterQueryClean = () =>
  action(Types.LOAD_HELPCENTER_QUERY_CLEAN);

export const loadHelpCenterSugestion = (query: string) =>
  action(Types.LOAD_HELPCENTER_SUGGESTION, { query });
export const loadHelpCenterSugestionSuccess = (suggestions: ISearchResult[]) =>
  action(Types.LOAD_HELPCENTER_SUGGESTION_SUCCESS, {
    faq: {
      categories: [],
      question: [],
      query: {
        searchTerm: '',
        results: []
      },
      suggestions: suggestions
    }
  });
export const loadHelpCenterSugestionFailure = (error: unknown) =>
  action(Types.LOAD_HELPCENTER_SUGGESTION_FAILURE, { error });

export const loadHelpCenterCategories = () =>
  action(Types.LOAD_HELPCENTER_CATEGORIES);
export const loadHelpCenterCategoriesSuccess = (
  categories: HelpCenterCategory[]
) => action(Types.LOAD_HELPCENTER_CATEGORIES_SUCCESS, { categories });
export const loadHelpCenterCategoriesFailure = (error: unknown) =>
  action(Types.LOAD_HELPCENTER_CATEGORIES_FAILURE, { error });

export const loadHelpCenterTopics = (categoryId: number) =>
  action(Types.LOAD_HELPCENTER_TOPICS, { categoryId });
export const loadHelpCenterTopicsSuccess = (
  categoryId: number,
  topics: HelpCenterTopic[]
) => action(Types.LOAD_HELPCENTER_TOPICS_SUCCESS, { categoryId, topics });
export const loadHelpCenterTopicsFailure = (error: unknown) =>
  action(Types.LOAD_HELPCENTER_TOPICS_FAILURE, { error });
